import CheckboxSectionFilter from './CheckboxSectionFilter';

export default CheckboxSectionFilter;
